import React from 'react'

import { useTranslation } from 'react-i18next'
import { Form, useSearchParams, useSubmit } from 'react-router-dom'

import Dropdown from '@components/shared/form/Dropdown'

const ITEMS = [
  { name: 'sort.recent', queryValue: 'most_recent' },
  { name: 'sort.mostPopular', queryValue: 'favorites' },
  { name: 'sort.title', queryValue: 'title' },
  { name: 'sort.composer', queryValue: 'composer' },
]

interface Props {
  order?: string | null
}
const OrderDropdown: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const submit = useSubmit()
  return (
    <Form role="search">
      <Dropdown
        variant="sm"
        name="order"
        borderless
        onChange={(e) => {
          const isFirstSearch = order === null
          submit(
            {
              ...Object.fromEntries(searchParams),
              order: e.target.value,
            },
            {
              replace: !isFirstSearch,
            }
          )
        }}
        selectClassName="text-base"
        value={order ?? ITEMS[0].queryValue}>
        {ITEMS.map(({ name, queryValue }) => (
          <option key={name} value={queryValue}>
            {t(name)}
          </option>
        ))}
      </Dropdown>
    </Form>
  )
}

export default OrderDropdown
